export const GET_MESSAGES = 'GET_MESSAGES_ELEMENTS';
export const GET_CHAT = 'GET_CHAT_ELEMENT';
